import React from "react";
import { Part, Track } from "./StackedMeter.styles";
import type { StackedMeterProps } from "./StackedMeter.types";

/** How a total splits (sent, failed, skipped…), as one bar. Hidden from screen readers; renders nothing when empty. */
export const StackedMeter: React.FC<StackedMeterProps> = ({ segments, className }) => {
  const shown = segments.filter((segment) => segment.value > 0);
  if (!shown.length) return null;
  return (
    <Track className={className} aria-hidden="true" data-testid="stacked-meter">
      {shown.map((segment, index) => (
        <Part key={`${segment.tone}-${index}`} $tone={segment.tone} $grow={segment.value} data-tone={segment.tone} />
      ))}
    </Track>
  );
};

export default StackedMeter;
